define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.importStyles = importStyles;
    function importStyles(app) {
        // app.importStylesText(styles.toString());
        // app.importStylesText(additionalStyles.toString());
    }
});
